// React, Next
import { useContext } from 'react'
import { useTranslation } from 'next-i18next'

// MUI
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// Custom
import Section from '@/components/sections/Section'
import StatisticCarrousel from '@/components/carrousel/StatisticCarrousel'
import { GlobalContext } from 'context/GlobalContextProvider'

// Style
import themeColors from 'assets/theme/colors'
import breakpoints from 'assets/theme/breakpoints'
import { getFontH2 } from '@/assets/theme/fonts'

export default function StatisticsSection() {
  const { t } = useTranslation('servicesOtCybersecurity')
  const { screenDimensions } = useContext(GlobalContext)

  const mobileMode = screenDimensions.width < breakpoints.desktopToMobile

  const cards = [
    {
      value: t('statistics.items.01.value'),
      text: t('statistics.items.01.text'),
      source: t('statistics.items.01.source')
    },
    {
      value: t('statistics.items.02.value'),
      text: t('statistics.items.02.text'),
      source: t('statistics.items.02.source')
    },
    {
      value: t('statistics.items.03.value'),
      text: t('statistics.items.03.text'),
      source: t('statistics.items.03.source')
    },
    {
      value: t('statistics.items.04.value'),
      text: t('statistics.items.04.text'),
      source: t('statistics.items.04.source')
    },
    {
      value: t('statistics.items.05.value'),
      text: t('statistics.items.05.text'),
      source: t('statistics.items.05.source')
    },
    {
      value: t('statistics.items.06.value'),
      text: t('statistics.items.06.text'),
      source: t('statistics.items.06.source')
    },
    {
      value: t('statistics.items.07.value'),
      text: t('statistics.items.07.text'),
      source: t('statistics.items.07.source')
    },
    {
      value: t('statistics.items.08.value'),
      text: t('statistics.items.08.text'),
      source: t('statistics.items.08.source')
    }
  ]

  const getContent = () => (
    <Box sx={{ width: '100%' }}>
      <Typography
        variant="h2"
        component="h2"
        fontSize={getFontH2()}
        sx={{
          color: themeColors.gray.mid,
          fontWeight: 400,
          textAlign: mobileMode ? 'center' : 'left',
          marginBottom: '2.5rem'
        }}
      >
        {t('statistics.title')}
      </Typography>

      <StatisticCarrousel cards={cards} />
    </Box>
  )

  // *** MAIN RENDER ***
  return <Section marginTop="6rem" content={getContent()} />
}
